import { configureStore } from "@reduxjs/toolkit";
// Reducers
import authReducer from "./slices/auth.slice";
import servicesReducer from "./slices/services.slice";
import skillsReducer from "./slices/skills.slice";
import worksReducer from "./slices/works.slice";
import generalReducer from "./slices/general.slice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    services: servicesReducer,
    skills: skillsReducer,
    works: worksReducer,
    general: generalReducer,
  },
});

export default store;
